import { ConnectedFacilityService } from '../../api';
import { DefaultQueryKeyFactory, QueryKeyFactoryGenerator } from '../../utils/query-keys-factory';

export const connectionRequestsQueryKeys = new QueryKeyFactoryGenerator<DefaultQueryKeyFactory>(
  'connection_facility',
  {}
)
  .includeList<Parameters<typeof ConnectedFacilityService.connectedFacilityList>[0]>()
  .getFactory();
